import { on } from "hammerjs";
import $ from "jquery";

$(function () {
  function whiteNavbar() {
    const masterHeader = $("header");
    //   Manually added white class to header makes it white always
    if (masterHeader.hasClass("white")) {
      const headerHeight = masterHeader.outerHeight();
      if ($(".nav-placeholder").length === 0) {
        const whiteDiv = $("<div class='nav-placeholder'></div>").css({
          height: headerHeight,
          backgroundColor: "white",
          width: "100%",
          zIndex: -1,
        });
        masterHeader.before(whiteDiv);
      } else {
        const headerHeight = masterHeader.outerHeight();
        $(".nav-placeholder").css({
          height: headerHeight,
        });
      }
    } else {
      // If not white, then change color on scroll
      $(window).on("scroll", function () {
        const scroll = $(document).scrollTop();

        updateHeaderClass(scroll);
      });

      function updateHeaderClass(scroll) {
        if (0 < scroll) {
          masterHeader.addClass("white");
        } else {
          masterHeader.removeClass("white");
        }
      }
    }
  }
  whiteNavbar();
  $(window).on("resize", function () {
    whiteNavbar();
  });
});
